import MeetingsManagementList from "./meetingsManagementList";
export default MeetingsManagementList;